<template>
  <div class="mx-1 my-2">
    <v-flex xs12 text-xs-center class="titre mt-1 pa-2">
      <h3>Trades history</h3>
    </v-flex>
    <v-data-table :headers="headers"  hide-actions :items="exchanged" class="elevation-0" style="overflow: auto; height:60vh;">
      <template  slot="items" slot-scope="props">
        <tr :class="`${props.item.type}`">
          <td class="text-xs-left">{{ `${(new Date(props.item.created_at)).getHours()}:${(new Date(props.item.created_at)).getMinutes()}:${(new Date(props.item.created_at)).getSeconds()}`}}</td>
          <td class="text-xs-left">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:0}).format(props.item.price) }}</td>
          <td class="text-xs-left">{{ new Intl.NumberFormat("en-US",{maximumFractionDigits:5}).format(props.item.amount)}}</td>
          <td class="text-xs-left">{{ new Intl.NumberFormat("fr-FR", {maximumFractionDigits:0}).format(props.item.total)}}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions,mapState } from "vuex";

export default {
   props: {
     asset: {
      type: String,
    },
    currency:{
      type:String
    },
     second:{
      type:String
    },
   },
  data() {
    return {
      headers: [
        { text: "Date", align: "left", sortable: false },
        { text: "Price", align: "left", sortable: false },
        { text: "Amount", sortable: false },
        { text: "Total", sortable: false }
      ]
    };
  },
  computed: {
     ...mapState({
    exchanged(state,getters) {
        return getters["exchanged/"+this.currency+this.second+"_exchanged"]
    },
   
    }),
  },
  mounted() {
    this.someAction();
  },
  methods: {
     ...mapActions({
        someAction (dispatch) {
        return dispatch("exchanged/bind_"+this.currency+this.second+"_exchanged")
      }
       })
  }
};
</script>
<style scoped>
.achat{
  color: green;
}
.vente{
  color: red;

}
div.titre{
  background-color: #046c84;
  color: #ffffff;
}
table.v-table thead tr th {
  font-size: 1.2em;
}
table.v-table tbody tr td {
  font-size: 16px;
}
</style>

<style scoped>
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: red; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
</style>
